// Centralized super admin check — update this list to grant super admin access
const SUPER_ADMIN_EMAILS = [
  "dhruvabrol@gmail.com",
  "tarikagulabani@gmail.com",
];

export function isSuperAdmin(email) {
  if (!email) return false;
  return SUPER_ADMIN_EMAILS.includes(email.toLowerCase());
}

export { SUPER_ADMIN_EMAILS };
